import InnerHTML from "dangerously-set-html-content";

import styles from "./RichText.module.css";

interface RichTextViewContentProps {
  value: string;
}

const parseTrixAttachmentContent = (payload: string | null): string | null => {
  if (!payload) {
    return null;
  }

  try {
    const parsed = JSON.parse(payload) as { content?: string };
    return parsed.content ?? null;
  } catch {
    return null;
  }
};

const stripTrailingCursorSpan = (body: HTMLElement): void => {
  let node: Element | null = body;

  while (node?.lastElementChild) {
    node = node.lastElementChild;
  }

  if (
    node &&
    node !== body &&
    node.tagName === "SPAN" &&
    (node.textContent ?? "").replace(/\uFEFF/g, "").trim() === ""
  ) {
    node.remove();
  }
};

const hydrateTrixAttachments = (value: string): string => {
  if (typeof DOMParser === "undefined") {
    return value;
  }

  const htmlDocument = new DOMParser().parseFromString(value, "text/html");

  htmlDocument
    .querySelectorAll("figure[data-trix-attachment]")
    .forEach(figure => {
      if (figure.innerHTML.trim() !== "") {
        return;
      }

      const payload = figure.getAttribute("data-trix-attachment");
      const content = parseTrixAttachmentContent(payload);

      if (content) {
        figure.innerHTML = content;
      }
    });

  stripTrailingCursorSpan(htmlDocument.body);

  return htmlDocument.body.innerHTML;
};

export const RichTextViewContent = ({ value }: RichTextViewContentProps) => (
  <div className={styles.richContent}>
    <InnerHTML html={hydrateTrixAttachments(value)} />
  </div>
);
